// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__17pGV","list":"BalanceDue_list__3t170","listRow":"BalanceDue_listRow__2Pe3l","total":"BalanceDue_total__3tPXg"};